// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // 1. PERBAIKAN: Ambil data user dari localStorage SAAT INISIALISASI
  // Agar saat refresh, data user tidak null (langsung ada isinya)
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("userData");
    try {
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (e) {
      return null;
    }
  });

  const [token, setToken] = useState(localStorage.getItem("authToken"));

  // Loading true hanya jika ada token tapi user belum terverifikasi (opsional)
  // Tapi logika Anda yang lama sudah oke, kita pertahankan.
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      api
        .get("/me")
        .then((response) => {
          setUser(response.data);
          // Update data terbaru ke localStorage
          localStorage.setItem("userData", JSON.stringify(response.data));
        })
        .catch(() => {
          // Token expired/invalid
          localStorage.removeItem("authToken");
          localStorage.removeItem("userData");
          setToken(null);
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const response = await api.post("/login", { email, password });

    // Pastikan struktur response API Anda sesuai di sini
    const accessToken = response.data.access_token; // atau .token
    const userData = response.data.user; // atau .data

    localStorage.setItem("authToken", accessToken);
    localStorage.setItem("userData", JSON.stringify(userData));

    // Simpan role secara eksplisit jika perlu (opsional, membantu debugging)
    // localStorage.setItem("role", userData.role);

    setToken(accessToken);
    setUser(userData);
  };

  const logout = async () => {
    try {
      await api.post("/logout");
    } catch (error) {
      console.error("Gagal logout di server:", error);
    } finally {
      setUser(null);
      setToken(null);
      localStorage.removeItem("authToken");
      localStorage.removeItem("userData");
      // localStorage.removeItem("role"); // Hapus jika Anda menyimpannya
    }
  };

  // 2. PERBAIKAN: Ekstrak 'role' agar mudah dipakai di PublicRoute
  // Asumsi: di dalam object user ada properti bernama 'role'
  // Jika role Anda berupa objek (misal: user.role.name), sesuaikan di sini.
  const role = user?.role?.nama_role || user?.role || null;

  return (
    <AuthContext.Provider value={{ user, token, role, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
